const routeKeys = [
  'campaign_edit_overview',
  'agency_dashboard',
] as const

type RouteMap = {
  [key in typeof routeKeys[number]]: string
}

const ROUTE_MAP: RouteMap = {
  campaign_edit_overview: '#/campaigns/:campaignId/edit',
  agency_dashboard: '#/agency/dashboard/agencies/all',
}

type LegacyRoute = {
  regex: RegExp,
  key: typeof routeKeys[number],
}

const LEGACY_ROUTES: LegacyRoute[] = [
  // @ts-expect-error TS1503
  { regex: /\/agency\/campaigns\/(?<campaignId>\d*)\/edit/, key: 'campaign_edit_overview' },
  { regex: /\/agency\/dashboard/, key: 'agency_dashboard' },
]

type GetNewRouteParams = {
  hash?: string,
  match: RegExpMatchArray,
  newRoute: string,
}

const getNewRoute = (params: GetNewRouteParams) => {
  const { hash = '', match: { groups }, newRoute } = params

  const hashValue = hash.replace(/^#/, '')

  if (!groups) return newRoute + hashValue

  let routeWithSubstitutions = newRoute

  Object.keys(groups).forEach((groupKey) => {
    const groupValue = groups[groupKey]

    if (groupValue){
      const regex = new RegExp(`:${groupKey}`, 'g')

      routeWithSubstitutions = routeWithSubstitutions.replaceAll(regex, groupValue)
    }
  })

  return routeWithSubstitutions + hashValue
}

function useLegacyRedirect() {
  const { location: { hash, pathname } } = window

  const matchedLegacyRoute = LEGACY_ROUTES.find(route => pathname.match(route.regex))
  if (!matchedLegacyRoute) return

  const match = pathname.match(matchedLegacyRoute.regex)
  if (!match) return

  // Root Path
  if (matchedLegacyRoute.key === 'agency_dashboard' && !hash){
    window.location.href = '/#/'
    return
  }

  const newRoute = ROUTE_MAP[matchedLegacyRoute.key]
  if (!newRoute) return

  const routeWithSubstitutions = getNewRoute({ hash, match, newRoute })
  if (!routeWithSubstitutions) return

  // Redirect User to new route
  // eslint-disable-next-line no-console
  console.log('Redirecting with useLegacyRedirect...')
  window.location.href = `/${routeWithSubstitutions}`
}

export default useLegacyRedirect
